import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 60 60"
      fill="none"
      style={{ marginRight: "20px" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2624_27)">
       
        <g mask="url(#mask0_2624_27)">
          <path d="M37.62 40.79H23.28V43.63H37.62V40.79Z" fill="#767C93" />
          <path
            d="M58.3 25.7903V27.8303H43.3C43.3 27.8303 32.05 27.3103 32.05 40.9003V40.9603H28.3V40.9103C28.51 39.0503 28.41 37.1703 27.99 35.3403C27.43 33.0003 26.27 30.8503 24.31 29.2603C21.92 27.3103 18.5 26.0803 15.12 25.8803C12.75 25.7403 10.4 26.1103 8.44 27.1103C7.2 27.7403 6.09 28.6003 5.16 29.6403C5.08 29.7203 5.01 29.8103 4.94 29.8903C4.83 30.0103 4.05 31.3003 3.93 31.3003H1.41L4 22.4003C5.15 20.0903 7.44 20.7503 7.44 20.7503L18.92 22.0103C19.13 22.0403 25.93 23.1903 28.58 26.8203H34.64C34.64 26.8203 36.48 26.8703 36.48 25.4803V20.5503L36.44 20.4703C36.9 20.2503 37.35 20.0103 37.78 19.7403C37.78 19.7403 40.81 17.1603 43.29 17.5903C43.72 17.6603 44.38 17.7903 45.17 17.9403C47.28 18.3403 50.34 18.9303 52.61 19.3803C54.37 19.7203 55.66 19.9803 55.66 19.9803C55.66 19.9803 57.95 20.4603 58.26 22.3203H58.18L55.19 22.3303C54.78 22.3303 54.44 22.7403 54.44 23.2403V24.8903C54.44 25.3903 54.78 25.8003 55.19 25.8003H58.31L58.3 25.7903Z"
            fill="#C63037"
          />
          <path
            d="M58.3 35.3303C58.3 35.3303 58.63 40.9503 54.49 40.9503C54.49 38.9203 53.83 36.9503 52.61 35.3303V27.8303H58.29V35.3303H58.3Z"
            fill="#767C93"
          />
          <path
            d="M52.62 27.8303V35.3303C49.51 31.1903 43.64 30.3503 39.5 33.4503C37.14 35.2203 35.75 38.0003 35.75 40.9503H32.06V40.9003C32.06 27.3103 43.31 27.8303 43.31 27.8303H52.63H52.62Z"
            fill="#767C93"
          />
          <path
            d="M27.99 35.3303C28.41 37.1603 28.51 39.0403 28.3 40.9003V40.9603H24.49C24.49 38.9403 23.84 36.9703 22.63 35.3503L22.95 35.3303H28H27.99Z"
            fill="#767C93"
          />
          <path
            d="M27.99 35.3301H22.94L22.62 35.3501C20.85 32.9801 18.07 31.5801 15.11 31.5801V25.8701C18.5 26.0601 21.92 27.3001 24.31 29.2501C26.26 30.8401 27.43 33.0001 27.98 35.3301H27.99Z"
            fill="#767C93"
          />
          <path
            d="M15.12 25.8603V25.9703V29.7603H5.30999L5.14999 29.6103C6.07999 28.5703 7.18999 27.7203 8.42999 27.0803C10.39 26.0903 12.74 25.7103 15.12 25.8503V25.8603Z"
            fill="#767C93"
          />
          <path
            d="M52.62 19.3602C50.35 18.9102 47.29 18.3202 45.18 17.9202L47.06 13.4702C47.06 13.4702 51.51 15.3402 52.62 19.3502V19.3602Z"
            fill="#767C93"
          />
          <path
            d="M36.48 20.5302V25.4602C36.48 26.8502 34.64 26.8002 34.64 26.8002H28.58C25.93 23.1702 19.13 22.0202 18.92 21.9902L21.09 22.2202C21.09 22.2202 30.26 23.3802 36.44 20.4502L36.47 20.5302H36.48Z"
            fill="#767C93"
          />
          <path
            d="M58.18 22.3102H55.4C54.88 22.3002 54.45 22.7002 54.44 23.2202V24.8702C54.45 25.3902 54.89 25.7902 55.4 25.7802H58.16C58.16 24.7802 58.08 23.3102 58.18 22.3102Z"
            fill="#DAE1EA"
          />
          <g opacity="0.5">
            <path
              d="M58.02 25.8401C57.19 25.8401 56.52 24.7001 56.52 23.8701C56.52 23.0401 57.19 22.3701 58.02 22.3701"
              fill="white"
            />
          </g>
          <path
            d="M36.74 9.89014H33.11C32.5025 9.89014 32.01 10.3826 32.01 10.9901V11.7301C32.01 12.3376 32.5025 12.8301 33.11 12.8301H36.74C37.3475 12.8301 37.84 12.3376 37.84 11.7301V10.9901C37.84 10.3826 37.3475 9.89014 36.74 9.89014Z"
            fill="#767C93"
          />
          <path
            d="M24.49 40.9501C24.49 46.1301 20.29 50.3301 15.11 50.3301C9.93001 50.3301 5.73001 46.1301 5.73001 40.9501C5.73001 35.7701 9.93001 31.5701 15.11 31.5701C20.29 31.5701 24.49 35.7701 24.49 40.9501Z"
            fill="#767C93"
          />
          <g opacity="0.25">
            <path
              d="M5.73999 41.0701C5.73999 41.0701 7.39999 48.3601 15.08 48.3601C22.76 48.3601 24.49 41.2501 24.49 41.2501C24.49 41.2501 24 50.1701 15.08 50.1701C6.15999 50.1701 5.73999 41.0701 5.73999 41.0701Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M24.49 40.9001C24.49 40.9001 22.92 33.6 15.25 33.6C7.57999 33.6 5.73999 40.7201 5.73999 40.7201C5.73999 40.7201 6.32999 31.8 15.25 31.8C24.17 31.8 24.49 40.91 24.49 40.91V40.9001Z"
              fill="white"
            />
          </g>
          <path
            d="M18.52 40.9501C18.52 42.8301 17 44.3601 15.12 44.3601C13.24 44.3601 11.71 42.84 11.71 40.96C11.71 39.08 13.23 37.55 15.11 37.55C16.99 37.55 18.51 39.0701 18.52 40.9501Z"
            fill="#DAE1EA"
          />
          <g opacity="0.5">
            <path
              d="M15.23 33.2902C15.03 33.2902 14.84 33.1902 14.73 33.0102L14.16 32.0902C13.98 31.8202 14.06 31.4602 14.33 31.2802C14.6 31.1002 14.96 31.1802 15.14 31.4502C15.14 31.4502 15.14 31.4602 15.15 31.4702L15.72 32.3902C15.89 32.6602 15.81 33.0302 15.53 33.2002C15.44 33.2602 15.33 33.2902 15.22 33.2902H15.23Z"
              fill="#494456"
            />
            <path
              d="M15.23 50.6103C15.03 50.6103 14.84 50.5103 14.73 50.3303L14.16 49.4103C13.98 49.1403 14.06 48.7803 14.33 48.6003C14.6 48.4203 14.96 48.5003 15.14 48.7703C15.14 48.7703 15.14 48.7803 15.15 48.7903L15.72 49.7103C15.89 49.9803 15.81 50.3503 15.53 50.5203C15.44 50.5803 15.33 50.6103 15.22 50.6103H15.23Z"
              fill="#494456"
            />
            <path
              d="M5.82999 41.7801C5.50999 41.7801 5.23999 41.5201 5.23999 41.1901C5.23999 40.9901 5.33999 40.8001 5.51999 40.6901L6.43999 40.1201C6.71999 39.9501 7.07999 40.0501 7.23999 40.3201C7.39999 40.5901 7.31999 40.9401 7.05999 41.1101L6.13999 41.6801C6.04999 41.7401 5.93999 41.7701 5.82999 41.7701V41.7801Z"
              fill="#494456"
            />
            <path
              d="M23.15 41.7803C22.83 41.7803 22.56 41.5203 22.56 41.2003C22.56 41.0003 22.66 40.8103 22.84 40.7003L23.76 40.1303C24.03 39.9503 24.39 40.0303 24.57 40.3003C24.75 40.5703 24.67 40.9303 24.4 41.1103C24.4 41.1103 24.39 41.1103 24.38 41.1203L23.46 41.6903C23.37 41.7503 23.26 41.7803 23.15 41.7803Z"
              fill="#494456"
            />
            <path
              d="M9.34998 35.4902C9.34998 35.4902 9.25998 35.4902 9.21998 35.4702L8.16998 35.2302C7.84998 35.1702 7.64998 34.8602 7.70998 34.5402C7.76998 34.2202 8.07998 34.0202 8.39998 34.0802C8.40998 34.0802 8.42998 34.0802 8.43998 34.0802L9.48998 34.3202C9.80998 34.3902 9.99998 34.7102 9.92998 35.0202C9.86998 35.2902 9.62998 35.4702 9.35998 35.4702L9.34998 35.4902Z"
              fill="#494456"
            />
            <path
              d="M21.59 47.7402C21.59 47.7402 21.5 47.7402 21.46 47.7202L20.41 47.4802C20.09 47.4102 19.9 47.0902 19.97 46.7802C20.04 46.4602 20.36 46.2702 20.67 46.3402L21.72 46.5802C22.04 46.6502 22.23 46.9702 22.16 47.2802C22.1 47.5502 21.86 47.7302 21.59 47.7302V47.7402Z"
              fill="#494456"
            />
            <path
              d="M8.69998 48.1402C8.69998 48.1402 8.60998 48.1402 8.56998 48.1202C8.25998 48.0502 8.05998 47.7302 8.12998 47.4202L8.36998 46.3702C8.43998 46.0502 8.75998 45.8602 9.07998 45.9302C9.39998 46.0002 9.58998 46.3202 9.51998 46.6402L9.27998 47.6902C9.21998 47.9502 8.97998 48.1402 8.70998 48.1402H8.69998Z"
              fill="#494456"
            />
            <path
              d="M20.95 35.9003C20.63 35.9003 20.36 35.6403 20.36 35.3103C20.36 35.2603 20.36 35.2203 20.38 35.1803L20.62 34.1303C20.69 33.8103 21.01 33.6203 21.32 33.6903C21.64 33.7603 21.83 34.0803 21.76 34.3903L21.52 35.4403C21.46 35.7103 21.22 35.8903 20.95 35.8903V35.9003Z"
              fill="#494456"
            />
            <path
              d="M12.07 33.8102C11.95 33.8102 11.83 33.7702 11.73 33.7002L10.85 33.0702C10.59 32.8802 10.53 32.5202 10.72 32.2502C10.91 31.9902 11.27 31.9302 11.54 32.1202L12.42 32.7502C12.68 32.9402 12.74 33.3002 12.55 33.5702C12.44 33.7202 12.26 33.8102 12.07 33.8102Z"
              fill="#494456"
            />
            <path
              d="M18.7 49.8102C18.58 49.8102 18.46 49.7702 18.36 49.7002L17.48 49.0702C17.22 48.8802 17.16 48.5202 17.35 48.2502C17.54 47.9902 17.9 47.9302 18.17 48.1202L19.05 48.7502C19.31 48.9402 19.37 49.3002 19.19 49.5702C19.08 49.7202 18.9 49.8202 18.71 49.8202L18.7 49.8102Z"
              fill="#494456"
            />
            <path
              d="M6.63 45.2502C6.51 45.2502 6.39 45.2102 6.29 45.1402C6.03 44.9502 5.97 44.5902 6.15 44.3202L6.78 43.4402C6.97 43.1802 7.34 43.1202 7.6 43.3102C7.86 43.5002 7.92 43.8702 7.73 44.1302L7.1 45.0002C6.99 45.1502 6.81 45.2502 6.62 45.2502H6.63Z"
              fill="#494456"
            />
            <path
              d="M22.63 38.6201C22.51 38.6201 22.39 38.5801 22.29 38.5101C22.03 38.3201 21.97 37.9601 22.15 37.6901L22.78 36.8101C22.97 36.5501 23.33 36.4901 23.6 36.6801C23.86 36.8701 23.92 37.2301 23.73 37.5001L23.1 38.3801C22.99 38.5401 22.81 38.6301 22.62 38.6301L22.63 38.6201Z"
              fill="#494456"
            />
            <path
              d="M6.40999 38.2702C6.08999 38.2702 5.82999 38.0002 5.82999 37.6802C5.82999 37.4002 6.03999 37.1502 6.31999 37.1102L7.37999 36.9302C7.69999 36.8802 7.99999 37.0902 8.04999 37.4102C8.09999 37.7302 7.88999 38.0302 7.56999 38.0802L6.50999 38.2602C6.50999 38.2602 6.44999 38.2602 6.40999 38.2602V38.2702Z"
              fill="#494456"
            />
            <path
              d="M22.41 44.9001C22.09 44.9001 21.83 44.6301 21.83 44.3101C21.83 44.0301 22.04 43.7801 22.32 43.7401L23.38 43.5601C23.7 43.5101 24 43.7201 24.05 44.0401C24.1 44.3601 23.89 44.6601 23.57 44.7101L22.51 44.8801C22.51 44.8801 22.45 44.8801 22.41 44.8801V44.9001Z"
              fill="#494456"
            />
            <path
              d="M11.72 50.0301C11.43 50.0301 11.19 49.8201 11.14 49.5401L10.97 48.4801C10.92 48.1601 11.13 47.8601 11.45 47.8101C11.77 47.7601 12.07 47.9701 12.12 48.2901L12.29 49.3501C12.34 49.6701 12.13 49.9701 11.81 50.0201C11.78 50.0201 11.75 50.0201 11.71 50.0201L11.72 50.0301Z"
              fill="#494456"
            />
            <path
              d="M18.35 34.0301C18.06 34.0301 17.82 33.8201 17.77 33.5401L17.6 32.4801C17.55 32.1601 17.76 31.8601 18.08 31.8101C18.4 31.7601 18.7 31.9701 18.75 32.2901L18.92 33.3501C18.97 33.6701 18.76 33.9701 18.44 34.0201C18.41 34.0201 18.38 34.0201 18.34 34.0201L18.35 34.0301Z"
              fill="#494456"
            />
          </g>
          <path
            d="M54.49 40.9501C54.49 46.1301 50.29 50.3301 45.11 50.3301C39.93 50.3301 35.73 46.1301 35.73 40.9501C35.73 35.7701 39.93 31.5701 45.11 31.5701C50.29 31.5701 54.49 35.7701 54.49 40.9501Z"
            fill="#767C93"
          />
          <g opacity="0.25">
            <path
              d="M35.83 41.0701C35.83 41.0701 37.41 48.3601 45.08 48.3601C52.75 48.3601 54.49 41.2501 54.49 41.2501C54.49 41.2501 54 50.1701 45.08 50.1701C36.16 50.1701 35.83 41.0701 35.83 41.0701Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M54.49 40.7902C54.49 40.7902 52.92 33.4902 45.25 33.4902C37.58 33.4902 35.75 40.6102 35.75 40.6102C35.75 40.6102 36.33 31.6902 45.25 31.6902C54.17 31.6902 54.49 40.7902 54.49 40.7902Z"
              fill="white"
            />
          </g>
          <path
            d="M48.52 40.9501C48.52 42.8301 47 44.3601 45.12 44.3601C43.24 44.3601 41.71 42.84 41.71 40.96C41.71 39.08 43.23 37.55 45.11 37.55C46.99 37.55 48.51 39.0701 48.52 40.9501Z"
            fill="#DAE1EA"
          />
          <g opacity="0.5">
            <path
              d="M45.23 33.2902C45.03 33.2902 44.84 33.1902 44.73 33.0102L44.16 32.0902C43.98 31.8202 44.06 31.4602 44.33 31.2802C44.6 31.1002 44.96 31.1802 45.14 31.4502C45.14 31.4502 45.14 31.4602 45.15 31.4702L45.72 32.3902C45.89 32.6602 45.81 33.0302 45.53 33.2002C45.44 33.2602 45.33 33.2902 45.22 33.2902H45.23Z"
              fill="#494456"
            />
            <path
              d="M45.23 50.6103C45.03 50.6103 44.84 50.5103 44.73 50.3303L44.16 49.4103C43.98 49.1403 44.06 48.7803 44.33 48.6003C44.6 48.4203 44.96 48.5003 45.14 48.7703C45.14 48.7703 45.14 48.7803 45.15 48.7903L45.72 49.7103C45.89 49.9803 45.81 50.3503 45.53 50.5203C45.44 50.5803 45.33 50.6103 45.22 50.6103H45.23Z"
              fill="#494456"
            />
            <path
              d="M35.83 41.7801C35.51 41.7801 35.24 41.5201 35.24 41.1901C35.24 40.9901 35.34 40.8001 35.52 40.6901L36.44 40.1201C36.72 39.9501 37.08 40.0501 37.24 40.3201C37.4 40.5901 37.32 40.9401 37.06 41.1101L36.14 41.6801C36.05 41.7401 35.94 41.7701 35.83 41.7701V41.7801Z"
              fill="#494456"
            />
            <path
              d="M53.15 41.7803C52.83 41.7803 52.56 41.5203 52.56 41.2003C52.56 41.0003 52.66 40.8103 52.84 40.7003L53.76 40.1303C54.03 39.9503 54.39 40.0303 54.57 40.3003C54.75 40.5703 54.67 40.9303 54.4 41.1103C54.4 41.1103 54.39 41.1103 54.38 41.1203L53.46 41.6903C53.37 41.7503 53.26 41.7803 53.15 41.7803Z"
              fill="#494456"
            />
            <path
              d="M39.35 35.4902C39.35 35.4902 39.26 35.4902 39.22 35.4702L38.17 35.2302C37.85 35.1702 37.65 34.8602 37.71 34.5402C37.77 34.2202 38.08 34.0202 38.4 34.0802C38.41 34.0802 38.43 34.0802 38.44 34.0802L39.49 34.3202C39.81 34.3902 40 34.7102 39.93 35.0202C39.87 35.2902 39.63 35.4702 39.36 35.4702L39.35 35.4902Z"
              fill="#494456"
            />
            <path
              d="M51.59 47.7402C51.59 47.7402 51.5 47.7402 51.46 47.7202L50.41 47.4802C50.09 47.4102 49.9 47.0902 49.97 46.7802C50.04 46.4602 50.36 46.2702 50.67 46.3402L51.72 46.5802C52.04 46.6502 52.23 46.9702 52.16 47.2802C52.1 47.5502 51.86 47.7302 51.59 47.7302V47.7402Z"
              fill="#494456"
            />
            <path
              d="M38.7 48.1402C38.7 48.1402 38.61 48.1402 38.57 48.1202C38.26 48.0502 38.06 47.7302 38.13 47.4202L38.37 46.3702C38.44 46.0502 38.76 45.8602 39.07 45.9302C39.39 46.0002 39.58 46.3202 39.51 46.6302L39.27 47.6902C39.21 47.9502 38.97 48.1402 38.7 48.1402Z"
              fill="#494456"
            />
            <path
              d="M50.95 35.9003C50.63 35.9003 50.36 35.6403 50.36 35.3103C50.36 35.2603 50.36 35.2203 50.38 35.1803L50.62 34.1303C50.69 33.8103 51.01 33.6203 51.32 33.6903C51.64 33.7603 51.83 34.0803 51.76 34.3903L51.52 35.4403C51.46 35.7103 51.22 35.8903 50.95 35.8903V35.9003Z"
              fill="#494456"
            />
            <path
              d="M42.07 33.8102C41.95 33.8102 41.83 33.7702 41.73 33.7002L40.85 33.0702C40.59 32.8802 40.53 32.5202 40.72 32.2502C40.91 31.9902 41.27 31.9302 41.54 32.1202L42.42 32.7502C42.68 32.9402 42.74 33.3002 42.55 33.5702C42.44 33.7202 42.26 33.8102 42.07 33.8102Z"
              fill="#494456"
            />
            <path
              d="M48.7 49.8102C48.58 49.8102 48.46 49.7702 48.36 49.7002L47.48 49.0702C47.22 48.8802 47.16 48.5202 47.35 48.2502C47.54 47.9902 47.9 47.9302 48.17 48.1202L49.05 48.7502C49.31 48.9402 49.37 49.3002 49.19 49.5702C49.08 49.7202 48.9 49.8202 48.71 49.8202L48.7 49.8102Z"
              fill="#494456"
            />
            <path
              d="M36.63 45.2502C36.51 45.2502 36.39 45.2102 36.29 45.1402C36.03 44.9502 35.97 44.5902 36.15 44.3202L36.78 43.4402C36.97 43.1802 37.33 43.1202 37.6 43.3102C37.86 43.5002 37.92 43.8602 37.73 44.1302L37.1 45.0102C36.99 45.1602 36.81 45.2602 36.62 45.2602L36.63 45.2502Z"
              fill="#494456"
            />
            <path
              d="M52.63 38.6201C52.51 38.6201 52.39 38.5801 52.29 38.5101C52.03 38.3201 51.97 37.9601 52.15 37.6901L52.78 36.8101C52.97 36.5501 53.33 36.4901 53.6 36.6801C53.86 36.8701 53.92 37.2301 53.73 37.5001L53.1 38.3801C52.99 38.5401 52.81 38.6301 52.62 38.6301L52.63 38.6201Z"
              fill="#494456"
            />
            <path
              d="M36.41 38.2702C36.09 38.2702 35.83 38.0002 35.83 37.6802C35.83 37.4002 36.04 37.1502 36.32 37.1102L37.38 36.9302C37.7 36.8802 38 37.0902 38.05 37.4102C38.1 37.7302 37.89 38.0302 37.57 38.0802L36.51 38.2602C36.51 38.2602 36.45 38.2602 36.41 38.2602V38.2702Z"
              fill="#494456"
            />
            <path
              d="M52.41 44.9001C52.09 44.9001 51.83 44.6301 51.83 44.3101C51.83 44.0301 52.04 43.7801 52.32 43.7401L53.38 43.5601C53.7 43.5101 54 43.7201 54.05 44.0401C54.1 44.3601 53.89 44.6601 53.57 44.7101L52.51 44.8801C52.51 44.8801 52.45 44.8801 52.41 44.8801V44.9001Z"
              fill="#494456"
            />
            <path
              d="M41.72 50.0301C41.43 50.0301 41.19 49.8201 41.14 49.5401L40.97 48.4801C40.92 48.1601 41.13 47.8601 41.45 47.8101C41.77 47.7601 42.07 47.9701 42.12 48.2901L42.29 49.3501C42.34 49.6701 42.13 49.9701 41.81 50.0201C41.78 50.0201 41.75 50.0201 41.71 50.0201L41.72 50.0301Z"
              fill="#494456"
            />
            <path
              d="M48.35 34.0301C48.06 34.0301 47.82 33.8201 47.77 33.5401L47.6 32.4801C47.55 32.1601 47.76 31.8601 48.08 31.8101C48.4 31.7601 48.7 31.9701 48.75 32.2901L48.92 33.3501C48.97 33.6701 48.76 33.9701 48.44 34.0201C48.41 34.0201 48.38 34.0201 48.34 34.0201L48.35 34.0301Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M25.23 22.3101C24.16 22.2501 23 22.1801 21.83 22.0901C22.88 22.7901 23.93 23.4501 25.19 23.9001C25.48 24.0101 25.74 24.1801 25.94 24.4001C28.26 24.4101 30.82 24.2501 32.92 23.6701C34.02 23.4201 35.11 23.0901 36.18 22.7001C36.28 21.8901 36.46 21.1001 36.61 20.3201C34.08 21.5201 30.11 22.5701 25.22 22.3201L25.23 22.3101Z"
              fill="white"
            />
          </g>
          <g opacity="0.3">
            <path
              d="M55.66 19.95C52.61 19.35 43.71 17.64 43.71 17.64C43.71 17.64 40.74 17.22 38.98 18.81C38.46 19.28 37.66 19.8 36.62 20.3C36.46 21.08 36.29 21.87 36.19 22.68C37.38 22.24 38.69 21.65 39.73 20.91C39.73 20.91 42.07 19.27 44.38 19.74C46.69 20.21 58.17 22.75 58.17 22.75C58.17 22.75 58.72 20.54 55.67 19.94L55.66 19.95Z"
              fill="white"
            />
          </g>
          <g opacity="0.3">
            <path
              d="M21.84 22.09C15.44 21.62 8.23001 20.81 8.23001 20.81C8.23001 20.81 4.86001 19.92 3.95001 22.8C3.95001 22.8 5.04001 22.14 7.35001 22.45C9.66001 22.76 19.58 23.97 19.58 23.97C21.7 24.24 23.83 24.38 25.96 24.39C25.75 24.17 25.49 24 25.21 23.89C23.95 23.44 22.9 22.78 21.85 22.08L21.84 22.09Z"
              fill="white"
            />
          </g>
          <g opacity="0.25">
            <path
              d="M5.16 29.6201C5.16 29.6201 10.15 24.3001 17.56 26.1801C24.97 28.0601 29.36 32.7501 28.31 40.9001H25.96C25.96 40.9001 27.49 32.2901 20.28 29.2401C13.07 26.1901 7.7 30.2201 7.7 30.2201L5.17 29.6201H5.16Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.25">
            <path
              d="M32.05 40.9001C32.05 40.9001 31.52 27.8301 43.3 27.8301H52.62V30.0001H43.42C43.42 30.0001 33.93 29.4101 33.93 40.9001H32.05Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.25">
            <path
              d="M58.3 34.3601C58.3 34.3601 58.01 38.3201 54.1 38.3901L54.49 40.9501C54.49 40.9501 58.36 41.2201 58.3 34.3601Z"
              fill="#494456"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M46.41 15.0002C46.41 15.0002 50.96 16.9502 52.3 19.3602C52.3 19.3602 52.15 15.6102 47.06 13.4702L46.42 14.9902L46.41 15.0002Z"
              fill="white"
            />
          </g>
          <path
            d="M58.18 26.37H55.18C54.45 26.37 53.85 25.7 53.85 24.87V23.22C53.85 22.4 54.45 21.72 55.18 21.72H58.18C58.5 21.72 58.77 21.98 58.77 22.31C58.77 22.64 58.51 22.9 58.18 22.9H55.18C55.18 22.9 55.02 23.01 55.02 23.22V24.87C55.02 25.08 55.14 25.19 55.18 25.19H58.18C58.5 25.19 58.77 25.45 58.77 25.78C58.77 26.11 58.51 26.37 58.18 26.37Z"
            fill="#494456"
          />
          <path
            d="M36.74 13.41H33.11C32.18 13.41 31.43 12.65 31.43 11.72V10.98C31.43 10.05 32.18 9.30004 33.11 9.29004H36.74C37.67 9.29004 38.42 10.05 38.42 10.98V11.72C38.42 12.65 37.67 13.4 36.74 13.41ZM33.11 10.47C32.83 10.47 32.6 10.7 32.6 10.98V11.72C32.6 12 32.83 12.23 33.11 12.23H36.74C37.02 12.23 37.25 12 37.25 11.72V10.98C37.25 10.7 37.02 10.47 36.74 10.47H33.11Z"
            fill="#494456"
          />
          <path
            d="M43.71 18.23C43.41 18.23 43.16 18.01 43.12 17.71L42.71 13.95C42.36 11.87 40.48 11.93 40.27 11.95H37.83C37.51 11.95 37.24 11.69 37.24 11.36C37.24 11.03 37.5 10.77 37.83 10.77H40.21C41.31 10.69 43.45 11.22 43.88 13.76C43.88 13.77 43.88 13.78 43.88 13.79L44.3 17.57C44.33 17.89 44.1 18.18 43.78 18.22H43.71V18.23Z"
            fill="#494456"
          />
          <path
            d="M15.12 50.91C9.62 50.91 5.16 46.45 5.16 40.95C5.16 35.45 9.62 30.99 15.12 30.99C20.62 30.99 25.08 35.45 25.08 40.95C25.08 46.45 20.62 50.9 15.12 50.91ZM15.12 32.16C10.27 32.16 6.33 36.09 6.33 40.95C6.33 45.81 10.26 49.74 15.12 49.74C19.98 49.74 23.91 45.81 23.91 40.95C23.91 36.1 19.97 32.17 15.12 32.16Z"
            fill="#494456"
          />
          <path
            d="M15.12 44.94C12.92 44.94 11.13 43.15 11.13 40.95C11.13 38.75 12.92 36.96 15.12 36.96C17.32 36.96 19.11 38.75 19.11 40.95C19.11 43.15 17.32 44.94 15.12 44.94ZM15.12 38.13C13.56 38.13 12.3 39.39 12.3 40.95C12.3 42.51 13.56 43.77 15.12 43.77C16.68 43.77 17.94 42.51 17.94 40.95C17.94 39.39 16.68 38.13 15.12 38.13Z"
            fill="#494456"
          />
          <path
            d="M45.12 50.91C39.62 50.91 35.16 46.45 35.16 40.95C35.16 35.45 39.62 30.99 45.12 30.99C50.62 30.99 55.08 35.45 55.08 40.95C55.08 46.45 50.62 50.9 45.12 50.91ZM45.12 32.16C40.27 32.16 36.33 36.09 36.33 40.95C36.33 45.81 40.26 49.74 45.12 49.74C49.98 49.74 53.91 45.81 53.91 40.95C53.91 36.1 49.97 32.17 45.12 32.16Z"
            fill="#494456"
          />
          <path
            d="M45.12 44.94C42.92 44.94 41.13 43.15 41.13 40.95C41.13 38.75 42.92 36.96 45.12 36.96C47.32 36.96 49.11 38.75 49.11 40.95C49.11 43.15 47.32 44.94 45.12 44.94ZM45.12 38.13C43.56 38.13 42.3 39.39 42.3 40.95C42.3 42.51 43.56 43.77 45.12 43.77C46.68 43.77 47.94 42.51 47.94 40.95C47.94 39.39 46.68 38.13 45.12 38.13Z"
            fill="#494456"
          />
          <path
            d="M15.12 41.6801C14.8 41.6801 14.53 41.4201 14.53 41.0901V40.9401C14.53 40.6201 14.79 40.3501 15.12 40.3501C15.45 40.3501 15.71 40.6101 15.71 40.9401V41.0901C15.71 41.4101 15.45 41.6801 15.12 41.6801Z"
            fill="#494456"
          />
          <path
            d="M45.12 41.6801C44.8 41.6801 44.53 41.4201 44.53 41.0901V40.9401C44.53 40.6201 44.79 40.3501 45.12 40.3501C45.45 40.3501 45.71 40.6101 45.71 40.9401V41.0901C45.71 41.4101 45.45 41.6801 45.12 41.6801Z"
            fill="#494456"
          />
          <path
            d="M35.74 41.5401H24.49C24.17 41.5401 23.9 41.2801 23.9 40.9501C23.9 40.6201 24.16 40.3601 24.49 40.3601H35.74C36.06 40.3601 36.33 40.6201 36.33 40.9501C36.33 41.2801 36.07 41.5401 35.74 41.5401Z"
            fill="#494456"
          />
          <path
            d="M54.49 41.54C54.17 41.54 53.9 41.28 53.9 40.95C53.9 40.62 54.16 40.36 54.49 40.36C55.34 40.36 56.01 40.09 56.52 39.55C57.85 38.14 57.71 35.39 57.71 35.36C57.71 35.33 57.71 35.34 57.71 35.33V22.74C57.71 21.01 55.56 20.54 55.54 20.54C55.45 20.52 45.64 18.59 43.2 18.16C41.02 17.78 38.19 20.15 38.16 20.18C38.14 20.2 38.12 20.21 38.09 20.23C35.48 21.88 31.81 22.82 27.18 23.01C25.12 23.1 23.06 23.04 21.02 22.81L7.37001 21.31C7.37001 21.31 7.30001 21.3 7.27001 21.29C7.09001 21.24 5.45001 20.84 4.54001 22.59L2.18001 30.68H3.67001C3.82001 30.47 4.07001 30.09 4.19001 29.92C4.37001 29.65 4.43001 29.55 4.49001 29.49C5.51001 28.29 6.76001 27.29 8.17001 26.57C10.53 25.37 13.57 24.97 16.72 25.44C19.77 25.89 22.59 27.08 24.68 28.79C27.89 31.41 29.42 35.84 28.88 40.96C28.86 41.28 28.57 41.52 28.25 41.5C27.93 41.48 27.69 41.19 27.71 40.87C27.71 40.86 27.71 40.85 27.71 40.83C28.21 36.12 26.83 32.06 23.94 29.7C19.85 26.36 13.01 25.43 8.69001 27.62C7.42001 28.27 6.30001 29.16 5.38001 30.25C5.35001 30.29 5.25001 30.45 5.16001 30.58C4.49001 31.6 4.31001 31.87 3.91001 31.87H1.41001C1.09001 31.87 0.820007 31.61 0.820007 31.28C0.820007 31.22 0.820007 31.17 0.840007 31.12L3.44001 22.23C3.44001 22.23 3.46001 22.16 3.48001 22.13C4.54001 20 6.57001 19.9 7.55001 20.17L21.17 21.66C21.29 21.68 31.61 22.93 37.45 19.27C37.82 18.96 40.81 16.56 43.41 17.02C45.87 17.45 55.69 19.39 55.79 19.4C56.33 19.53 56.84 19.74 57.31 20.03C58.35 20.69 58.9 21.62 58.9 22.75V35.33C58.92 35.6201 59.02 38.64 57.39 40.37C56.65 41.16 55.67 41.56 54.5 41.56L54.49 41.54Z"
            fill="#494456"
          />
          <path
            d="M15.12 32.1601C14.8 32.1601 14.53 31.9001 14.53 31.5701V25.9601C14.53 25.6401 14.79 25.3701 15.12 25.3701C15.45 25.3701 15.71 25.6301 15.71 25.9601V31.5701C15.71 31.8901 15.45 32.1601 15.12 32.1601Z"
            fill="#494456"
          />
          <path
            d="M14.94 30.3499H5.31C4.99 30.3499 4.72 30.0899 4.72 29.7599C4.72 29.4299 4.98 29.1699 5.31 29.1699H14.94C15.26 29.1699 15.53 29.4299 15.53 29.7599C15.53 30.0899 15.27 30.3499 14.94 30.3499Z"
            fill="#494456"
          />
          <path
            d="M8.82002 34.59C8.65002 34.59 8.48002 34.51 8.37002 34.38L4.71002 30C4.50002 29.75 4.54002 29.38 4.78002 29.17C5.03002 28.96 5.40002 29 5.61002 29.24L9.27002 33.6199C9.48002 33.8699 9.45002 34.24 9.20002 34.45C9.09002 34.54 8.96002 34.59 8.82002 34.59Z"
            fill="#494456"
          />
          <path
            d="M34.68 27.3899H28.59C28.4 27.3899 28.23 27.2999 28.12 27.1499C25.6 23.6999 18.9 22.5799 18.83 22.5699C18.51 22.5299 18.29 22.2299 18.33 21.9099C18.37 21.5899 18.67 21.3699 18.99 21.4099C18.99 21.4099 19.01 21.4099 19.02 21.4099C20.36 21.6499 21.67 21.9999 22.95 22.4599C25.68 23.4399 27.67 24.6999 28.89 26.2199H34.69C34.9 26.2199 35.47 26.1599 35.74 25.8899C35.85 25.7799 35.91 25.6199 35.9 25.4599V20.5299C35.9 20.2099 36.16 19.9399 36.49 19.9399C36.82 19.9399 37.08 20.1999 37.08 20.5299V25.4599C37.09 25.9399 36.9 26.3899 36.57 26.7299C35.93 27.3499 34.94 27.3899 34.69 27.3899H34.68Z"
            fill="#494456"
          />
          <path
            d="M27.99 35.91H22.94C22.62 35.91 22.35 35.65 22.35 35.32C22.35 34.99 22.61 34.73 22.94 34.73H27.99C28.31 34.73 28.58 34.99 28.58 35.32C28.58 35.65 28.32 35.91 27.99 35.91Z"
            fill="#494456"
          />
          <path
            d="M52.62 35.91C52.3 35.91 52.03 35.65 52.03 35.32V27.82C52.03 27.5 52.29 27.23 52.62 27.23C52.95 27.23 53.21 27.49 53.21 27.82V35.32C53.21 35.64 52.95 35.91 52.62 35.91Z"
            fill="#494456"
          />
          <path
            d="M32.05 41.4799C31.73 41.4799 31.46 41.2199 31.46 40.8899C31.46 36.2699 32.73 32.7199 35.22 30.3399C38.59 27.1199 42.96 27.2299 43.31 27.2399H58.31C58.63 27.2399 58.9 27.4999 58.9 27.8299C58.9 28.1599 58.64 28.4199 58.31 28.4199H43.27C43.27 28.4199 39.09 28.2699 36.02 31.2099C33.77 33.3499 32.63 36.6099 32.63 40.8999C32.63 41.2199 32.37 41.4899 32.04 41.4899L32.05 41.4799Z"
            fill="#494456"
          />
          <path
            d="M52.62 19.9399C52.36 19.9399 52.13 19.7599 52.06 19.5099C51.26 16.6199 48.52 14.8799 47.36 14.2699L45.73 18.1399C45.6 18.4399 45.26 18.5799 44.96 18.4499C44.66 18.3199 44.52 17.9799 44.65 17.6799L46.53 13.2299C46.66 12.9299 47 12.7899 47.3 12.9199C47.49 12.9999 52.03 14.9499 53.21 19.1899C53.3 19.4999 53.11 19.8199 52.8 19.9099C52.75 19.9299 52.69 19.9299 52.64 19.9299L52.62 19.9399Z"
            fill="#494456"
          />
          <path
            d="M36.13 44.21H24.1C23.78 44.21 23.51 43.95 23.51 43.62C23.51 43.29 23.77 43.03 24.1 43.03H36.13C36.45 43.03 36.72 43.29 36.72 43.62C36.72 43.95 36.46 44.21 36.13 44.21Z"
            fill="#494456"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2624_27">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
